import * as zod from 'zod';

export const ActuateGripperVariables = zod.object({
  succeeded: zod.boolean(),
});

export type ActuateGripperVariables = zod.infer<typeof ActuateGripperVariables>;
